export default "__VITE_PUBLIC_ASSET__7b849899__"